import * as toastr from 'toastr';
import '../scss/styles.scss';
import './main';
import 'bootstrap';
import { ValidationManager } from './validationManager';
import { BudgetControl } from './components/budget';
import { initPortalFileUpload } from './components/portalFileUpload';
import { initAiFormFill } from './components/aiFormFill';

// Only what the portal's views call. Backoffice-only widgets (form/taskflow editor, reporting, dashboard) live in backoffice.ts.

window.toastr = toastr;

export { ValidationManager, BudgetControl, initPortalFileUpload, initAiFormFill };
